import { StaticImageData } from "next/image";

export interface RefBrandingConfig {
  logoPath: string | StaticImageData;
  alt: string;
  width?: number;
  height?: number;
}

/**
 * RefConfig interface for the RefConfig component
 * @interface RefConfig
 * @property {string} ref - The reference name of the ref
 * @property {string} country - Forced country code (e.g., "SG", "MY")
 * @property {boolean} showCountrySwitcher - Whether to show the country switcher
 * @property {boolean} skipECF - Skip ECF-related features
 * @property {object} branding - Branding configuration
 * @property {boolean} branding.showAltaLogo - Whether to show the Alta logo
 * @property {array} branding.additionalLogos - Additional logos to show
 * @property {string} branding.additionalLogos[].logoPath - The path to the logo
 * @property {string} branding.additionalLogos[].alt - The alt text for the logo
 * @property {number} branding.additionalLogos[].width - The width of the logo
 * @property {number} branding.additionalLogos[].height - The height of the logo
 */
export interface RefConfig {
  ref: string;
  country: string;
  showCountrySwitcher: boolean;
  skipECF: boolean;
  branding?: {
    showAltaLogo?: boolean;
    additionalLogos?: RefBrandingConfig[];
  };
}

export const frackfrackRefConfig: RefConfig = {
  ref: "frackfrack",
  country: "SG",
  showCountrySwitcher: false,
  skipECF: true,
  branding: {
    showAltaLogo: true,
    additionalLogos: [
      {
        logoPath: "/img/partner/frackfrack/slogan-logo.svg",
        alt: "FrackFrack Logo",
        width: 150,
        height: 60,
      },
    ],
  },
};

export const refConfigArray: RefConfig[] = [frackfrackRefConfig];
